import { ListItemAvatar, ListItemText, Typography, ListItem, Avatar } from "@mui/material"
import { Fragment } from "react"
import { IUser } from "@/redux/models"

const NameItem = ({ user }: { user: IUser }) => {
    return (

        <ListItem sx={{ px: 0 }}>
            <ListItemAvatar>
                <Avatar alt={`${user.nombre} ${user.apellido}`} src={user.fotoPerfil} />
            </ListItemAvatar>
            <ListItemText
                primary={`${user.nombre} ${user.apellido}`}
                secondary={
                    <Fragment>
                        <Typography
                            sx={{ display: 'inline' }}
                            component="span"
                            variant="body2"
                            color="text.primary"
                        >
                        </Typography>
                        {user.email}
                    </Fragment>
                }
            />
        </ListItem>

    )
}

export default NameItem;